import { render, staticRenderFns } from "./testInterpretation.vue?vue&type=template&id=4e5cb378&scoped=true"
import script from "./testInterpretation.vue?vue&type=script&lang=js"
export * from "./testInterpretation.vue?vue&type=script&lang=js"
import style0 from "./testInterpretation.vue?vue&type=style&index=0&id=4e5cb378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5cb378",
  null
  
)

export default component.exports